var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.1 46.5L67.7 23.7c-2.4-2.1-6-1.9-8.1.4-2.1 2.4-1.9 6 .4 8.1l13.6 12.2H10.7C7.5 44.4 5 47 5 50.1c0 3.2 2.6 5.7 5.7 5.7h63.5l-14 11.8c-2.4 2-2.7 5.7-.7 8.1 1.1 1.4 2.8 2.1 4.4 2.1 1.3 0 2.6-.4 3.7-1.3L93 55.1c1.3-1.1 2-2.6 2.1-4.3 0-1.6-.7-3.2-2-4.3z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48cGF0aCBkPSJNOTMuMSA0Ni41TDY3LjcgMjMuN2MtMi40LTIuMS02LTEuOS04LjEuNC0yLjEgMi40LTEuOSA2IC40IDguMWwxMy42IDEyLjJIMTAuN0M3LjUgNDQuNCA1IDQ3IDUgNTAuMWMwIDMuMiAyLjYgNS43IDUuNyA1LjdoNjMuNWwtMTQgMTEuOGMtMi40IDItMi43IDUuNy0uNyA4LjEgMS4xIDEuNCAyLjggMi4xIDQuNCAyLjEgMS4zIDAgMi42LS40IDMuNy0xLjNMOTMgNTUuMWMxLjMtMS4xIDItMi42IDIuMS00LjMgMC0xLjYtLjctMy4yLTItNC4zeiIvPjwvc3ZnPg==";
export { SvgArrow as ReactComponent };